/* eslint-disable no-magic-numbers */
import { graphql } from '@apollo/client/react/hoc'
import { get } from 'lodash'
import { DateTime } from '../../helpers/date-helpers'
import { ApplicationError } from '../../helpers/errors'
import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({ centre }) => {
  const start = DateTime.local({ timeZone: centre.timeZone })
  const end = start.clone().add(14, 'days')
  return {
    context: { version: 1 },
    errorPolicy: 'ignore',
    variables: {
      centreID: centre.sys.id,
      startsAt: start.toISODate(),
      endsAt: end.toISODate(),
    },
  }
}

export const mapDataToProps = ({ data: { error, loading, centre } }) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  }

  return {
    centreTradingHours: centre
      ? {
          tradingHours: get(centre, ['centreTradingSchedule', 'tradingHours']),
          timeZone: centre.timeZone,
          features: centre.features || [],
        }
      : null,
  }
}

const withCentreTradingHours = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withCentreTradingHours
